<template>
  <div class="mainContainer">
  <div class="main-admin" v-if="mainRole===1">
    <div class="mainHead">
    </div>

    <div class="mainCellOne">
      <ul class="mainCellOne-totel">
        <li class="mainCellOne-totel-li">
          <span class="mainCellOne-totel-span">
            <img src="../../assets/images/store.png" class="mainCellOne-totel-img"/>
            <span class="mainCellOne-totel-name"> 总商户</span>
          </span>
          <span class="mainCellOne-totel-money">{{mch}}</span>
        </li>
        <li class="mainCellOne-totel-li">
          <span class="mainCellOne-totel-span">
            <img src="../../assets/images/company.png" class="mainCellOne-totel-img"/>
            <span class="mainCellOne-totel-name"> 总企业</span>
          </span>
          <span class="mainCellOne-totel-money">{{company}}</span>
        </li>
        <li class="mainCellOne-totel-li noBorder">
          <span class="mainCellOne-totel-span">
            <img src="../../assets/images/user.png" class="mainCellOne-totel-img"/>
            <span class="mainCellOne-totel-name"> 总用户</span>
          </span>
          <span class="mainCellOne-totel-money">{{user}}</span>
        </li>
      </ul>
      <div class="mainCellOne-bill">
        <div class="billTotel">
            <div class="billTotel-card billTotel-border">
              <div class="billTotel-first colorGreen">今日交易笔数</div>
              <div class="billTotel-second colorGreen">{{tradeDay}}</div>
              <div class="billTotel-third">总交易笔数 {{tradeAll}}</div>
            </div>
            <div class="billTotel-card">
              <div class="billTotel-first colorPurpe">今日利润</div>
              <div class="billTotel-second colorPurpe">{{profitDay}}</div>
              <div class="billTotel-third">总利润 {{profitAll}}</div>
            </div>
        </div>
        <div class="billPayment">
            <span class="billTotel-first colorBlue">今日用户消费流水</span>
            <span class="billTotel-second colorBlue">{{amountDay}}</span>
            <span class="billTotel-third">总消费流水 {{amountAll}}</span>
        </div>
      </div>
    </div>

    <div class="mainCellTwo">
      <div class="mainPlatform">
        <div class="mainCell-title">平台重要指标走势</div>
        <div class="lineChartBox">
        <div class="lineChartBox-title">
          <div class="btnChart" :class="{btnChartSel: sel===1}" @click="lineWeek">近一周</div>
          <div class="btnChart" :class="{btnChartSel: sel===2}" @click="lineMonth">近一月</div>
        </div>
        <div class="lineChart">
          <lineChart :chart-data="lineChartData" :height="lineChartHeight"></lineChart>
        </div>
        <div class="lineChart">
          <lineSingleChart :chart-data="lineSingleChartData" :height="lineChartHeight"></lineSingleChart>
        </div>
        <div class="lineChartIntro">
          <div class="lineChartIntro-tip">
            <span class="lineChartIntro-point colorLiu"></span>
            <span class="lineChartIntro-font">流水</span>
          </div>
          <div class="lineChartIntro-tip">
            <span class="lineChartIntro-point colorLi"></span>
            <span class="lineChartIntro-font">利润</span>
          </div>
          <div class="lineChartIntro-tip">
            <span class="lineChartIntro-point colorBill"></span>
            <span class="lineChartIntro-font">交易笔数</span>
          </div>
        </div>
        </div>
      </div>
      <div class="mainCellTwo-card">
      <div class="mainPending marginBot20">
        <div class="mainCell-title">待处理事务</div>
        <ul v-if="hasMsg">
          <li v-for="item in dataPending" :key="item.index" class="pending-li">
              <div class="pending-li-left">
                <i class="el-icon-mobile-phone"></i>
                <span>{{item.name}}</span>
                <span> {{item.count}}条</span>
              </div>
              <div class="pending-li-right" @click="pendingTo(item.router)">查看</div>
          </li>
        </ul>
        <div v-if="!hasMsg" class="mainNoMsg">
          暂无处理
        </div>
      </div>
      <div class="mainPending">
        <div class="mainCell-title">商家销售排行(前五名)</div>
        <ul v-if="hasTop">
          <li class="top-li">
            <span class="top-li-span">商铺名称</span>
            <span class="top-li-span">本月入账流水</span>
          </li>
          <li v-for="(item,index) in dataTop" :key="index" class="top-li">
            <div v-if="index <3" class="top-li-row">
              <div class="pending-li-left">
                <img v-if="index ==0" src="../../assets/images/royal1.png" class="royal"/>
                <img v-if="index ==1" src="../../assets/images/royal2.png" class="royal"/>
                <img v-if="index ==2" src="../../assets/images/royal3.png" class="royal"/>
                <span v-if="index ==0" class="pending-li-top  colorTopOne">{{item.name}}</span>
                <span v-if="index ==1" class="pending-li-top  colorTopTwo">{{item.name}}</span>
                <span v-if="index ==2" class="pending-li-top  colorTopThree">{{item.name}}</span>
              </div>
              <div v-if="index==0" class="pending-li-top colorTopOne" >{{item.amount}}</div>
              <div v-if="index==1" class="pending-li-top colorTopTwo" >{{item.amount}}</div>
              <div v-if="index==2" class="pending-li-top colorTopThree" >{{item.amount}}</div>
            </div>
            <div v-if="index >=3" class="top-li-row">
              <div class="pending-li-left">
                <span>TOP {{index+1}}</span>
                <span class="pending-li-top ">{{item.name}}</span>
              </div>
              <div class="pending-li-top">{{item.amount}}</div>
            </div>
          </li>
        </ul>
        <div v-if="!hasTop" class="mainNoMsg">
          暂无排名
        </div>
      </div>
      </div>
    </div>

    <div class="mainCellThree">
      <div class="mainPie mainMargin">
        <div class="mainCell-title">
          用户活跃度
          <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
            <span class="el-icon-waring"></span>
          </el-tooltip>
        </div>
        <div>
          <pieRing :chart-data="pieChartData" :height="pieChartHeight"></pieRing>
        </div>
      </div>
      <div class="mainPie">
        <div class="mainCell-title">支付渠道</div>
        <div>
          <pieArea :chart-data="pieChartArea" :height="areaChartHeight"></pieArea>
        </div>
      </div>
    </div>
  </div>

  <div class="main-finance" v-if="mainRole===2">
    <div class="mainHead">
      <div class="mainCompanyPay" v-if="showCompany"  @click="companyPay">
        企业充值
      </div>
    </div>

    <div class="mainFinance">
      <div class="marginTen mainFinance-card">
        <img src="../../assets/images/finance1.png" class="mainFinance-img"/>
        <div class="mainFinance-content">
          <div class="mainFinaceFont">待提现审核</div>
          <div class="mainFinance-withraw">{{financeOne}}</div>
        </div>
        <div class="mainFinance-check" @click="checkWithdraw(1)">立即查看</div>
      </div>
      <div class="marginTen mainFinance-card">
        <img src="../../assets/images/finance2.png" class="mainFinance-img"/>
        <div class="mainFinance-content">
          <div class="mainFinaceFont">待交发票</div>
          <div class="mainFinance-bill">{{financeTwo}}</div>
        </div>
        <div class="mainFinance-check"  @click="checkWithdraw(2)">立即查看</div>
      </div>
      <div class="mainFinance-card">
        <img src="../../assets/images/finance3.png" class="mainFinance-img"/>
        <div class="mainFinance-content">
          <div class="mainFinaceFont">待转账</div>
          <div class="mainFinance-transfer">{{financeThree}}</div>
        </div>
        <div class="mainFinance-check" @click="checkWithdraw(3)">立即查看</div>
      </div>
    </div>

    <div class="mainFinance-info">
      <div class="mainFinance-title">通知</div>
      <ul class="mainFinance-ul">
        <li v-for="item in infoList" :key="item.index"  v-if="item.TYPE === 1" class="mainFinanceInfo-li" @click="financeInfo(item.STATUS)">
          <span>商户 <span class="mainFinanceInfo-font">{{item.NAME}}</span> {{showMsg(item.status)}}<span>，提现金额 ￥{{item.amount | toFixed}}</span> </span>
          <span>{{time(item.createTime)}}</span>
        </li>
        <li v-for="item in infoList" :key="item.index"  v-if="item.TYPE === 2" class="mainFinanceInfo-li" @click="financeWithdrawInfo">
          <span><span class="mainFinanceInfo-font">{{item.realname}}</span> 给 <span class="mainFinanceInfo-font">{{item.NAME}}</span> {{item.platfSubject}}</span>
          <span>{{item.createTime}}</span>
        </li>
      </ul>
    </div>

  </div>
  <div class="main-other" v-if="mainRole===3">
    <ul class="main-other-totel">
        <li class="main-other-totel-li marginRight20">
          <span class="mainCellOne-totel-span">
            <img src="../../assets/images/store.png" class="mainCellOne-totel-img"/>
            <span class="mainCellOne-totel-name"> 总商户</span>
          </span>
          <span class="mainCellOne-totel-money">{{mch}}</span>
        </li>
        <li class="main-other-totel-li marginRight20">
          <span class="mainCellOne-totel-span">
            <img src="../../assets/images/company.png" class="mainCellOne-totel-img"/>
            <span class="mainCellOne-totel-name"> 总企业</span>
          </span>
          <span class="mainCellOne-totel-money">{{company}}</span>
        </li>
        <li class="main-other-totel-li">
          <span class="mainCellOne-totel-span">
            <img src="../../assets/images/user.png" class="mainCellOne-totel-img"/>
            <span class="mainCellOne-totel-name"> 总用户</span>
          </span>
          <span class="mainCellOne-totel-money">{{user}}</span>
        </li>
      </ul>
    <div class="mainCellThree">
      <div class="mainPie mainMargin">
        <div class="mainCell-title">用户活跃度
           <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
            <span class="el-icon-waring"></span>
          </el-tooltip>
        </div>
        <div>
          <pieRing :chart-data="pieChartData" :height="pieChartHeight"></pieRing>
        </div>
      </div>
      <div class="mainPie">
        <div class="mainCell-title">支付渠道</div>
        <div>
          <pieArea :chart-data="pieChartArea" :height="areaChartHeight"></pieArea>
        </div>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
import lineChart from '@/components/lineEchart';
import lineSingleChart from '@/components/lineSingleEchart';
import pieRing from '@/components/pieRingEchart';
import pieArea from '@/components/pieAreaEchart';
import store from '@/store';
import { mainTime,financeTime,toFixed } from '@/utils';
import { getCookie } from '@/utils/common';
import { findCheck,topFive,findMonthPayment,findMonthActive,findWithdraw,findWithdrawInfo,allCount,trade,profit,amount,weekLine,monthLine } from '@/api/homeApi';

const lineChartData = {
  pieRing: {
    expectedData: {val: 0, name: ''},
    actualData: {val: 0, name: ''}
  },
  pieArea:{
    wxData: {val: 0, name: ''},
    appData: {val: 0, name: ''},
    aliData: {val: 0, name: ''},
  }
}

export default {
  name: "",
  store,
  components: {
    lineChart,
    lineSingleChart,
    pieRing,
    pieArea,
  },
  props: [""],
  data() {
    return {
      hasMsg: false,                               //判断消息列表是否有消息
      hasTop: false,                               //判断排名前五名
      sel: 1,                                      //图标按钮样式
      mainRole: 1,                                //判断角色
      lineChartHeight: '280px',                   //折线图高度
      pieChartHeight: '260px',                    //饼图高度
      areaChartHeight: '360px',                   //饼图样式二高度
      dataPending:[{name:'待审核提现',count: 0, router: '待审核'}],
      infoList: [],                           //待处理事务 销售排行
      lineChartData: {                         //流水利润表
        expectedData: [],
        actualData: [],
        week: [],
      },
      lineSingleChartData:{                     //交易笔数表
        expectedData: [],
        week: [],
      },
      pieChartData: lineChartData.pieRing,
      pieChartArea: lineChartData.pieArea,
      dataTop: [],
      userName: '',                                //用户名
      roleName: '',                                //角色
      lastTime: '',                                //上次登录时间
      financeOne: '',                              //待提现审核
      financeTwo: '',                              //待交发票
      financeThree: '',                            //待转账
      user: 0,                                     //总用户
      company: 0,                                  //总企业
      mch: 0,                                      //总商户
      tradeDay: 0,                                 //今日交易
      tradeAll: 0,                                 //总交易
      profitDay: 0,                                //今日利润
      profitAll: 0,                                //总利润
      amountDay: 0,                                //今日流水
      amountAll: 0,                                //总流水
      financeCash: false,                          //财务 待体现审核权限
      financeBill: false,                          //财务 待交发票
      financeWait: false,                          //财务 待转账
      showCompany: false,                          //是否显示企业充值
    }
  },
  filters: {
    toFixed(value) {
      if(!value) return '';
      return Number(value).toFixed(2);
    }
  },
  mounted(){
    let self =this;
    let id = getCookie('roleId');
    let menuThree = JSON.parse(getCookie('listThreeMenu'));
    menuThree.forEach(item => {
       //待审核
       if(item.id  == 34){
         self.financeCash = true;
       }
       //代交发票
       if(item.id == 35){
         self.financeBill = true;
       }
       //待转账
       if(item.id == 36){
         self.financeWait = true;
       }
       //企业充值
       if(item.id == 33){
         self.showCompany = true;
       }
      //  //提现完成
      //  if(item.id == 37){
      //    console.log('4',item.name);
      //    all++
      //  }
    });
    let lastTime = getCookie('lastLoginTime');
    self.userName = getCookie('userName');
    self.roleName = getCookie('roleName');
    self.lastTime = mainTime(lastTime);
    if(id  == 1){
      self.mainRole = 1;
      self.findCheck();
      self.topFive();
      self.findMonthPayment();
      self.findMonthActive();
      self.allCount();
      self.trade();
      self.profit();
      self.amount();
      self.weekLine();
    }else if(self.financeCash || self.financeBill || self.financeWait){
      self.mainRole = 2;
      self.findWithdraw();
      self.findWithdrawInfo();
    }else{
      self.mainRole = 3;
      self.findMonthPayment();
      self.allCount();
    }



  },
  methods: {
    //查看代办事务
    pendingTo(page){
      if(page =='待审核'){
        self.financeRole = 1;
        this.checkWithdraw();
      }
    },
    //时间转换
    time(val){
     return financeTime(val);
    },
    //近一周
    lineWeek(){
      this.sel = 1;
      this.weekLine();
    },
    //近一个月
    lineMonth(){
      this.sel = 2;
      this.monthLine();
    },
    //待处理事务
    findCheck(){
      // findCheck().then(res=>{
      //   if(res.data.acount){
      //     this.dataPending[0].count = res.data.acount;
      //     this.hasMsg = true;
      //   }else{
      //     this.hasMsg = false;
      //   }
      // }).catch(err=>{})
    },
    // 商家销售排行(前五名)
    topFive(){
      topFive().then(res=>{
        if(res.data.topFive){
          this.dataTop = res.data.topFive;
          this.hasTop = true;
        }else{
          hasTop = false;
        }
      }).catch(err=>{})
    },
    //支付终端
    findMonthPayment(){
      findMonthPayment().then(res=>{
        let { list,countByMonth } = res.data;
        for(let i=0;i<list.length;i++){
          if(list[i].channel === 1){
            lineChartData.pieArea.appData.val = list[i].acount?list[i].acount:0;
            lineChartData.pieArea.appData.name = '园区APP '+(list[i].acount/countByMonth).toFixed(2)*100 +'%';
          }else if(list[i].channel === 2){
            lineChartData.pieArea.wxData.val = list[i].acount?list[i].acount:0;
            lineChartData.pieArea.wxData.name = '微信用户 '+(list[i].acount/countByMonth).toFixed(2)*100 + '%';
          }else if(list[i].channel === 3){
            lineChartData.pieArea.aliData.val = list[i].acount?list[i].acount:0;
            lineChartData.pieArea.aliData.name = '支付宝 '+(list[i].acount/countByMonth).toFixed(2)*100 +'%';
          }
          if(lineChartData.pieArea.aliData.val === 0){
            lineChartData.pieArea.aliData.name = '支付宝 0%';
          }
          if(lineChartData.pieArea.wxData.val === 0){
            lineChartData.pieArea.wxData.name = '微信用户 0%';
          }
          if(lineChartData.pieArea.appData.val === 0){
            lineChartData.pieArea.appData.name = '园区APP 0%';
          }
        }
      }).catch(err=>{})
    },
    //用户活跃度
    findMonthActive(){
      findMonthActive().then(res=>{
        let {monthActive,allUser} = res.data
        lineChartData.pieRing.expectedData.val = monthActive;
        lineChartData.pieRing.actualData.val = (allUser -monthActive);
        lineChartData.pieRing.expectedData.name = '活跃用户 '+ ((monthActive/allUser).toFixed(2))*100+'%';
        lineChartData.pieRing.actualData.name = '不活跃用户 '+(1 - ((monthActive/allUser))).toFixed(2)*100+'%';
      }).catch(err=>{})
    },
    // 财务界面待提现审核、代交发票、待转账
    findWithdraw(){
      findWithdraw().then(res=>{
        let self = this;
        let { list } = res.data;
        for(let i=0;i<list.length;i++){
          if(list[i].status==0){
            self.financeOne = list[i].count
          }
          if(list[i].status==1){
            self.financeTwo = list[i].count
          }
          if(list[i].status == 2){
            self.financeThree = list[i].count
          }
        }
      }).catch(err=>{})
    },
    //查询提现进程详细信息
    findWithdrawInfo(){
      findWithdrawInfo().then(res=>{
        this.infoList = res.data.list;
        console.log('infoList', this.infoList)
      }).catch(err=>{

      })
    },
    //企业充值
    companyPay(){
      this.$router.push('/main/recharge')
    },
    //财务查看待提现、代交发票、待转账
    checkWithdraw(type){
      switch (type){
        case 1:
         //待提现
         if(this.financeCash){
          this.$router.push({path:'main/CashManagement'});
          }else{
            this.$notify({
                title: "提示",
                message:'大佬，你还没有此权限',
                type:'warning',
                duration: 800
              });
          }
          break;
        case 2:
          //代交发票
          if(this.financeBill){
            this.$router.push({path:'main/Bill'});
          }else{
            this.$notify({
                title: "提示",
                message:'大佬，你还没有此权限',
                type:'warning',
                duration: 800
              });
          }
          break;
          case 3:
            //待转账
            if(this.financeWait){
              this.$router.push({path:'main/waitturn'});
            }else{
              this.$notify({
                  title: "提示",
                  message:'大佬，你还没有此权限',
                  type:'warning',
                  duration: 800
                });
            }
            break;
      }





    },
    //财务界面  通知 跳转到提现进度
    financeInfo(type){
      // this.$router.push({
      //   path: '/main/deposit',
      //   query: { id: mchId }
      // });
      switch (type){
        //发起提现等待审核
        case 0:
          return this.$router.push({path: 'main/CashManagement'});
          break;
        //待交发票
        case 1:
          return this.$router.push({path: 'main/Bill'});
          break;
        //发票审核通过等待转账
        case 2:
          return this.$router.push({path: 'main/waitturn'});
          break;
        //提现成功（财务已打款）
        case 3:
          return this.$router.push({path: 'main/complete'});
          break;
        //提现失败
        case 4:
          return this.$router.push({path: 'main/complete'});
          break;
        default:
           return false;

      }
    },
    //财务界面通知 查询企业充值
    financeWithdrawInfo(){
      this.$router.push('/main/recharge');
    },
    // 查询总用户、总商户、总企业
    allCount(){
      let self = this;
      allCount().then(res=>{
        let {mch,company,user} = res.data;
        self.mch = mch;
        self.company = company;
        self.user = user;
      })
    },
    // 查询日交易总数和总交易数
    trade(){
      trade().then(res=>{
        let {tradeByDay,allUser } = res.data;
        this.tradeDay = tradeByDay;
        this.tradeAll = allUser;
      }).catch(err=>{})
    },
    //查询日利润和总利润
    profit(){
      profit().then(res=>{
        let { profitByDay,allProfits} =res.data;
        this.profitDay = toFixed(profitByDay);
        this.profitAll = toFixed(allProfits);
      }).catch(err=>{})
    },
    //查询日流水和总流水
    amount(){
      amount().then(res=>{
        let { amountByDay,allAmount} = res.data
        this.amountDay = toFixed(amountByDay);
        this.amountAll = toFixed(allAmount)
      }).catch(err=>{})
    },
    //查询一周内图表信息
    weekLine(){
      let self = this;
      self.lineChartData.expectedData = [];
      self.lineChartData.actualData = [];
      self.lineChartData.week = [];
      self.lineSingleChartData.week = [];
      self.lineSingleChartData.expectedData = [];
      weekLine().then(res=>{
        let { list } = res.data;
        for(let i=0;i<list.length;i++){
          self.lineChartData.expectedData.push(list[i].amount);
          self.lineChartData.actualData.push(list[i].platProfit);
          self.lineChartData.week.push(list[i].time);
          self.lineSingleChartData.week.push(list[i].time);
          self.lineSingleChartData.expectedData.push(list[i].count);
        }
      }).catch(err=>{});
    },
    //查询一个月图表信息
    monthLine(){
      let self = this;
      self.lineChartData.expectedData = [];
      self.lineChartData.actualData = [];
      self.lineChartData.week = [];
      self.lineSingleChartData.week = [];
      self.lineSingleChartData.expectedData = [];
      monthLine().then(res=>{
        let { list } = res.data;
        for(let i=0;i<list.length;i++){
          self.lineChartData.expectedData.push(list[i].amount);
          self.lineChartData.actualData.push(list[i].platProfit);
          self.lineChartData.week.push(list[i].time);
          self.lineSingleChartData.week.push(list[i].time);
          self.lineSingleChartData.expectedData.push(list[i].count);
        }
      }).catch(err=>{})
    },
    //财务首页 通知 商户提现进度
    showMsg(type){
      switch (type){
        case 0:
          return '发起提现等待审核';
          break;
        case 1:
          return '待交发票';
          break;
        case 2:
          return '发票审核通过等待转账';
          break;
        case 3:
          return '提现成功（财务已打款）';
          break;
        case 4:
          return '提现失败';
          break;
        default:
          return '';
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../style/mixin";
@import "../../style/_variables";
.mainContainer{
  min-width: 1000px;
  padding: 10px;
  height: 100%;
}

.marginTen{
  margin-right: 10px;
}

.noBorder{
  border: none!important;
}
.mainHead{
  @include flex-row;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.mainHead-info{
  @include flex-row;
  justify-content: flex-start;
}

.mainHead-img{
  width: 60px;
  height: 60px;
  border-radius: 60px;
}

.mainHead-role{
  margin-left: 15px;
}

.mainHead-role-title{
  display: flex;
  flex-direction: row;
  align-items: flex-start;

}

.mainHead-role-admin{
  border: 1px solid #000;
  font-size: 12px;
  border-radius: 10px;
  padding: 2px 5px;
  margin-left: 10px;
}

.mainHead-role-time{
  display: flex;
  margin-top: 4px;
  font-size: 12px;
  align-items: flex-start;
}

.mainCellOne{
  width: 100%;
  @include flex-row;
}

.mainCellOne-totel{
  flex: 1;
  background-color: #fff;
  padding: 0 40px;
  height: 300px;
}
.mainCellOne-totel-li{
  padding: 28px 0;
  border-bottom: 1px solid #EBF4F7;
  @include flex-row;
  justify-content: space-between;
}

.mainCellOne-totel-span{
  @include flex-row;
}

.mainCellOne-totel-name{
  font-size: 14px;
  color: #526069;
  margin-left: 10px;
}
.mainCellOne-totel-money{
  font-size: 30px;
  color: #7D8893;
  font-family: 'Arial Black';
}
.mainCellOne-totel-img{
  width: 38px;
  height: 38px;
}

.mainCellOne-bill{
  flex:2;
  background-color: #fff;
  margin-left: 20px;
  height: 300px;
  @include flex-column;
}

.billTotel{
  width: 90%;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-bottom: 1px solid #EBF4F7;
}
.billTotel-card{
  flex: 1;
}
.billTotel-first{
  font-size: 18px;
  margin-bottom: 2px;
}
.colorGreen{
  color: #55DA8D;
}
.billTotel-second{
  font-size: 36px;
  font-family: 'Arial Black';
  margin-bottom: 10px;
}
.colorPurpe{
  color: #CE84DE;
}
.billTotel-third{
  font-size: 14px;
  color: #7d8893;
}
.colorBlue{
  color: #60B8F6;
}
.billTotel-border{
  border-right: 1px solid #EBF4F7;
}
.billPayment{
  width: 100%;
  flex: 1;
  @include flex-column;
  background-image: url('../../assets/images/first.png');
  background-size: 100% 100%;
}

.billTotel-card{
  @include flex-column;
  padding: 0 20px;
}
.mainCellTwo{
  width: 100%;
  display: flex;
  flex-flow: row;
  margin-top: 20px;
}
.mainPlatform{
  width: 750px;
  height: 680px;
  background-color: #fff;
}
.mainCell-title{
  font-size: 18px;
  color: #526069;
  border-bottom: 1px solid #EBF4F7;
  padding:10px 15px;
  text-align: left;
}
.mainCellTwo-card{
  flex: 1;
}
.mainPending{
  // width: 100%;
  height: 330px;
  margin-left: 20px;
  // margin-bottom: 17px;
  background-color: #fff;
}
.mainNoMsg{
  height: 240px;
  @include flex-row;
}
.pending-li{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 15px 20px;
}
.top-li{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 20px;
}
.top-li-span{
  font-size: 12px;
  color: #A3ACB5;
}
.top-li-row{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.mainCellThree{
  width: 100%;
  @include flex-row;
  margin-top: 20px;
}
.mainPie{
  flex: 1;
  height: 300px;
  background-color: #fff;
}
.mainMargin{
  margin-right: 20px;
}

.mainCompanyPay{
  padding: 5px 20px;
  background-color: #00A0E9;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  color: #fff;
}
.mainFinance{
  @include flex-row;
  justify-content: space-around;
}
.mainFinance-card{
  flex: 1;
  background-color: #fff;
  height: 140px;
  @include flex-row;
  padding: 0 25px;
}
.mainFinance-img{
  // flex: 1;
  width: 40px;
  height: 50px;
}
.mainFinance-content{
  flex: 2;
  text-align: left;
  margin-left: 20px;
}
.mainFinance-check{
  flex: 1;
  cursor: pointer;
  font-size: 14px;
  color: #007EE9;
}
.mainFinaceFont{
  font-size: 14px;
  color: #323232;
}
.mainFinance-withraw{
  color: #5384F1;
  font-size: 36px;
  margin-top: 5px;
}
.mainFinance-bill{
  color: #F39800;
  font-size: 36px;
  margin-top: 5px;
}
.mainFinance-transfer{
  color: #31CF83;
  font-size: 36px;
  margin-top: 5px;
}
.mainFinance-info{
  width: 100%;
  margin-top: 10px;
  background-color: #fff;
}
.mainFinance-ul{
  padding: 10px 20px;
}
.mainFinanceInfo-li{
  @include flex-row;
  justify-content: space-between;
  padding: 10px 0;
  cursor: pointer;
}
.mainFinanceInfo-li span{
  font-size: 14px;
  color: #323232;
}
.mainFinanceInfo-font{
  color: #007ee9!important;
}
.lineChartBox{
  margin-left: 30px;
}
.lineChartBox-title{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.btnChart{
  width: 64px;
  height: 32px;
  border-radius: 16px;
  line-height: 32px;
  font-size: 12px;
  color: #7acd82;
  text-align: center;
  cursor: pointer;
  margin-right: 4px;
  margin-top: 10px;
}
.btnChartSel{
  background-color: #7acd82;
  color: #fff;
}
.lineChart{
  // margin-left: 30px;
  width: 100%;
}
.lineChartIntro{
  width: 100%;
  @include flex-row;
}
.lineChartIntro-tip{
  margin-right: 30px;
}
.lineChartIntro-point{
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  margin-right: 5px;
  // background-color: #000;
}
.lineChartIntro-font{
  font-size: 12px;
}
.colorLiu{
  background-color: #FF005A;
}
.colorLi{
  background-color: #3888fa;
}
.colorBill{
  background-color: #55DA8D;
}
.royal{
  width: 24px;
  height: 14px;;
}
.pending-li-top{
  font-size: 14px;
  color: #7D8893;
}
.colorTopOne{
  color: #F11928;
}
.colorTopTwo{
  color: #F15119;
}
.colorTopThree{
  color: #F19319
}
.mainFinance-title{
  font-size: 14px;
  color: #323232;
  border-bottom: 1px solid #EBF4F7;
  padding:10px 15px;
  text-align: left;
}
.marginBot20{
  margin-bottom: 20px;
}
.main-other-totel{
  @include flex-row;
  justify-content: space-between;
}
.main-other-totel-li{
  padding: 28px 10px;
  flex: 1;
  background-color: #fff;
  border-bottom: 1px solid #EBF4F7;
  @include flex-row;
  justify-content: space-between;
}
.marginRight20{
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/first/index.vue